<div *ngIf="aberto" class="modal-v2-fundo z-[400] p-4">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloCadastroPaciente"
       class="modal-v2" style="max-width: 680px; max-height: 92vh">

    <div class="modal-v2-topo">
      <div class="flex-1 min-w-0">
        <p class="modal-v2-eyebrow">Paciente sem cadastro</p>
        <h3 id="tituloCadastroPaciente" class="modal-v2-titulo">Cadastrar paciente</h3>
        <p class="modal-v2-sub">Os campos marcados com <span style="color: var(--brand-primary); font-weight: 700">*</span> são obrigatórios.</p>
      </div>
      <button type="button" (click)="fechar.emit()" title="Fechar" class="modal-v2-fechar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div class="px-7 pb-6 overflow-y-auto flex-1 flex flex-col gap-5" style="min-height: 0">

      <section class="flex flex-col gap-3">
        <p class="form-v2-secao">Dados pessoais</p>
        <div class="form-v2-grade">
          <label>
            <span class="rotulo-v2">CPF <span class="obrigatorio">*</span></span>
            <input [value]="form.cpf" (input)="somenteDigitos('cpf', 11, $event)" inputmode="numeric" class="campo-v2" />
          </label>
          <label>
            <span class="rotulo-v2">Data de nascimento <span class="obrigatorio">*</span></span>
            <input type="date" [(ngModel)]="form.nascimento" class="campo-v2" />
          </label>
          <label>
            <span class="rotulo-v2">Sexo <span class="obrigatorio">*</span></span>
            <select [(ngModel)]="form.sexo" class="campo-v2">
              <option value="">Selecione</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
              <option value="I">Indefinido</option>
            </select>
          </label>
          <label class="inteiro">
            <span class="rotulo-v2">Nome completo <span class="obrigatorio">*</span></span>
            <input [(ngModel)]="form.nome" class="campo-v2" />
          </label>
          <label>
            <span class="rotulo-v2">Nome social</span>
            <input [value]="form.nomeSocial" (input)="onNomeSocialInput($event)" class="campo-v2" />
            <span *ngIf="nomeSocialInvalido" style="font-size: 11px; color: #B4003C">{{ MENSAGEM_NOME_SOCIAL_INVALIDO }}</span>
          </label>
          <label>
            <span class="rotulo-v2">Celular com DDD <span class="obrigatorio">*</span></span>
            <input [value]="formatarCelular(form.celular)" (input)="onCelularInput($event)" inputmode="tel"
                   maxlength="15" placeholder="(85) 99999-0000" class="campo-v2" />
          </label>
          <label>
            <span class="rotulo-v2">Estado civil</span>
            <select [(ngModel)]="form.estadoCivil" class="campo-v2">
              <option value="">Não informado</option>
              <option value="1">Solteiro(a)</option>
              <option value="2">Casado(a)</option>
              <option value="3">Divorciado(a)</option>
              <option value="6">Separado(a)</option>
              <option value="9">Outros</option>
            </select>
          </label>
          <label class="inteiro">
            <span class="rotulo-v2">E-mail</span>
            <input type="email" [(ngModel)]="form.email" class="campo-v2" />
          </label>
        </div>
      </section>

      <section class="flex flex-col gap-3 pt-5" style="border-top: 1px solid #EFE9DD">
        <div>
          <p class="form-v2-secao">Endereço</p>
          <p style="font-size: 12px; color: var(--tx-2); margin-top: 2px">Opcional. Se preencher, complete todos os campos.</p>
        </div>
        <div class="form-v2-grade">
          <label>
            <span class="rotulo-v2">CEP</span>
            <input [value]="form.cep" (input)="somenteDigitos('cep', 8, $event)" (blur)="buscarCep()" inputmode="numeric"
                   class="campo-v2" />
            <span *ngIf="isBuscandoCep" style="font-size: 11px; color: var(--tx-2)">Buscando endereço...</span>
          </label>
          <label class="dois">
            <span class="rotulo-v2">Rua</span>
            <input [(ngModel)]="form.rua" class="campo-v2" />
          </label>
          <label>
            <span class="rotulo-v2">Número</span>
            <input [value]="form.numero" (input)="somenteDigitos('numero', 5, $event)" inputmode="numeric" class="campo-v2" />
          </label>
          <label>
            <span class="rotulo-v2">Complemento</span>
            <input [(ngModel)]="form.complemento" maxlength="40" class="campo-v2" />
          </label>
          <label>
            <span class="rotulo-v2">Bairro</span>
            <input [(ngModel)]="form.bairro" class="campo-v2" />
          </label>
          <label class="dois">
            <span class="rotulo-v2">Cidade</span>
            <input [(ngModel)]="form.cidade" class="campo-v2" />
          </label>
          <label>
            <span class="rotulo-v2">UF</span>
            <input [(ngModel)]="form.uf" maxlength="2" class="campo-v2 uppercase" />
          </label>
        </div>
      </section>

      <div *ngIf="erros.length" class="rounded-xl px-4 py-3" style="background-color: #FDECEF; border: 1px solid #F6C9D3; color: #B4003C">
        <p *ngFor="let erro of erros" style="font-size: 12px">{{ erro }}</p>
      </div>
    </div>

    <div class="flex items-center justify-end gap-2 px-7 py-4"
         style="border-top: 1px solid #EFE9DD; background-color: var(--flua-rodape); border-radius: 0 0 18px 18px; flex-shrink: 0">
      <button type="button" (click)="fechar.emit()"
              class="px-6 bg-white dark:bg-transparent"
              style="height: 44px; border-radius: 10px; border: 1px solid var(--flua-borda); font-size: 14px; font-weight: 600; color: var(--tx-2)">
        Cancelar
      </button>
      <button type="button" (click)="salvar()" [disabled]="isSalvando"
              class="px-6 text-white"
              style="height: 44px; border-radius: 10px; font-size: 14px; font-weight: 700"
              [style.background-color]="isSalvando ? '#E5DFD4' : 'var(--brand-secondary)'"
              [style.color]="isSalvando ? '#8796A1' : '#fff'">
        {{ isSalvando ? 'Cadastrando...' : 'Cadastrar paciente' }}
      </button>
    </div>
  </div>
</div>
